<template lang="pug">
    .vacations
      div Dein Urlaubsanspruch: {{ vacationData.vacation_days }}
      div Bereits in Anspruch genommen: {{ vacationData.used_vacation_days_till_today }}
      div Geplante Urlaubstage: {{ vacationData.planned_vacation_days }}
      div Resturlaub (heute): {{ vacationData.open_vacation_days }}
      div
        strong Neuen Urlaub einreichen
      form
        label Von:
        input(type='date' name="start" v-model="new_vacation.start" required @change="setEnd")
        label Bis:
        input(type='date' name="end" v-model="new_vacation.end" required)
        br
        div(v-if="error")
          br
          span.error {{ error }}
        br
        button(@click="submitVacation") Urlaub Beantragen

      div
        strong Eingereichte Urlaube
        vacation(:vacation="vacation" :user="user"
          v-on:reload-vacations="$emit('reload-vacations'); loadVacationData()"
          v-for="vacation in vacations" :key="vacation.id")
        div(v-if="vacations.length == 0") keine

      div
        strong.otherVacations(
          @click="showOtherVacations=!showOtherVacations"
          :class="{'visible': showOtherVacations}"
          ) Urlaub in meinen Gewerken
      div(v-if="showOtherVacations")
        dl.vacation(v-for="vacation in otherVacations" :key="vacation.id")
          dt(:class="vacation.status") Von {{ vacation.start | moment('DD.MM.YYYY') }}
          dd bis {{ vacation.end | moment('DD.MM.YYYY')}} - {{ vacation.name }}
        span(v-if="otherVacations.length == 0") keine

      div
        strong Legende
        dl.legend
          dt.new &nbsp;
          dd Unbearbeitet
        dl.legend
          dt.accepted &nbsp;
          dd Genehmigt
        dl.legend
          dt.denied &nbsp;
          dd Abgelehnt

</template>

<script>
export default {
  name: 'vacations',
  props: ['vacations', 'user'],
  data () {
    return {
      new_vacation: {
        start: undefined,
        end: undefined
      },
      showOtherVacations: false,
      otherVacations: [],
      loginToken: this.$localStorage.get('loginToken'),
      error: undefined,
      vacationData: {}
    }
  },
  methods: {
    submitVacation (event) {
      this.error = undefined
      if (!this.new_vacation.start || !this.new_vacation.end) {
        // trigger native form validation
      } else {
        event.preventDefault()
        this.$http.post('/vacations/', this.new_vacation).set({Authorization: 'jwt ' + this.loginToken})
        .accept('json')
        .then(res => {
          this.$emit('reload-vacations')
          this.new_vacation.start = undefined
          this.new_vacation.end = undefined
          this.new_vacation.used_days = undefined
          this.loadVacationData()
        }).catch((error, dings) => {
          let errorMessage = JSON.parse(error.response.text)
          this.error = errorMessage.non_field_errors[0]
        })
      }
    },
    setEnd () {
      if (!this.new_vacation.end || this.new_vacation.end < this.new_vacation.start) {
        this.new_vacation.end = this.new_vacation.start
      }
    },
    loadVacationData () {
      this.$http.get('/calendar/vacationdata/').set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.vacationData = res.body
        }).catch(() => {})
    },
    loadOtherVacations () {
      this.$http.get('/other-vacations/').set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.otherVacations = res.body
        }).catch(() => {})
    }
  },
  created () {
    this.loadVacationData()
    this.loadOtherVacations()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.otherVacations
  cursor: pointer

  &:before
    margin-right: 1rem
    content: '›'
    font-size: 1.4rem
    font-weight: bold
    display: inline-block
    transition: all 0.2s linear
  &.visible
    &:before
      transform: rotate(90deg)

input
  width: 110px
  margin-right: 10px

label
  width: 40px
  display: inline-block
  break-before: column

.vacations
  min-height: 50px

  dt, dd
    display: inline-block
    font-weight: normal
    margin-bottom: 1px
  dt
    width: 120px
    border-left: 4px solid #eef12b
    padding-left: .8em
    &.accepted
      border-color: #83BC47
    &.denied
      border-color: #bc4755

  .legend
    dt
      width: 3%
    dd
      width: 90%

  .error
    color: #bc4755

input[type="date"]::-webkit-calendar-picker-indicator
    //display: none;
    //-webkit-appearance: none;
    width: 15px
    padding: 2px
    margin: 0

.delete, .delete:hover
  float: right
  height: 18px
  width: 18px
  background-color: hsla(0,0%,4%,.1)

strong
  margin-top: 2em
  display: block

</style>



// WEBPACK FOOTER //
// Vacations.vue?4720b064